import { defineComponent as _defineComponent } from 'vue'
import { Icon } from '@/ui/components/icon/Icon';
  import type { CourseReportItem, CourseReportSection } from '@/entities/trainings/course-report/model';
  import { COURSE_TYPE } from '@/entities/trainings';

  
export default /*#__PURE__*/_defineComponent({
  __name: 'CourseReportTable',
  props: {
    items: {
      type: Array as () => Array<CourseReportItem>,
      required: true,
    },
    section: {
      type: Object as () => CourseReportSection,
      required: false,
    },
  },
  setup(__props) {

  

  const itemIcon = (item: CourseReportItem) => {
    switch (item.type) {
      case COURSE_TYPE.TEXT:
        return 'align-left';
      case COURSE_TYPE.VIDEO:
        return 'play';
      case COURSE_TYPE.QUIZ:
        return 'question-square';
      case COURSE_TYPE.IMAGE:
        return 'image';
      default:
        return 'align-left';
    }
  };

return { __sfc: true,itemIcon, Icon }
}

})